import React from "react";
import pkg from "../../package.json";

export function Footer() {
    return (
        <div
            style={{
                position: "fixed",
                bottom: 10,
                left: 10,
                fontSize: "12px",
                opacity: 0.6
            }}
        >
            © SparcliVision - Powered by Floud srl - v{pkg.version}
        </div>
    );
}
